import ResidenceSelector from './ResidenceSelector';

export default ResidenceSelector;
